module.exports = __webpack_public_path__ + "static/media/avatar_24.50be99d5.svg";